// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3KwsI","title":"ClientReferral_title__1o9EL","itemText":"ClientReferral_itemText__1udNq"};